<template>
  <div>
    <span class="sr-only" aria-live="polite">{{ alertText }}</span>

    <div id="activity_instructions" class="text-white p-4">{{ $t('To move each pattern, either drag and drop the column to a new position, or tab to a column and use the left or right arrow keys to change position.') }}</div>

    <div class="flex flex-wrap items-center flex-col-reverse md:flex-col">
      <ul class="w-full flex flex-row px-4 text-white text-sm lg:text-2xl font-bold">
          <li class="flex-grow mb-0 mx-1 overflow-hidden text-center">
              <div class="text-left">{{ $t('Most Like Me') }}</div>
          </li>
          <li class="flex-grow mb-0 mx-1 overflow-hidden text-center">
              <div class="block"></div>
          </li>
          <li class="flex-grow mb-0 mx-1 overflow-hidden text-center">
              <div class="block"></div>
          </li>
          <li class="flex-grow mb-0 mx-1 overflow-hidden text-center">
              <div class="text-right">{{ $t('Least Like Me') }}</div>
          </li>
      </ul>

      <div class="sort-wrapper w-full lg:mb-3">
        <draggable :list="itemsarray"
          animation="600"
          tag="ul"
          class="flex flex-row px-4"
          :move="onMove"
        >
          <li v-for="(choice, index) in itemsarray"
            :id="choice.column"
            class="columnfill flex-grow mb-0 mx-1 py-3 overflow-hidden text-center rounded shadow-lg"
            :key="choice.id"
            :ref="'header_' + index"
            role="option"
            draggable="true"
            tabindex="1"
            @keyup.arrow-left="arrowLeft('header', choice, index)"
            @keyup.arrow-right="arrowRight('header', choice, index)"
          >
              <span class="block align-middle cursor-move">
                <h2 class="align-middle text-base font-bold pt-0">{{ choice.attributes['title'].text }}</h2>
              </span>
          </li>
        </draggable>
      </div>

      <h4 class="block md:hidden text-white text-center pt-0">{{ $t('Use these to rank from Most to Least') }}</h4>
  <div class="hrank-wrapper py-3">
        <div class="labels-container hrank-item relative">
              <div class="flex-grow h-full align-middle">

                <div v-if="labelsarray.length > 2" class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center">
                    <div class="cell" v-for="(labels, index) in labelsarray" :id="['item'] + index">
                        <span v-if="labels.label == 'showmore'" class="label container">{{ $t('Show More') }}</span>
                      <span v-else class="label container">{{ labels.label }}</span>
                    </div>
                </div>
                <!-- IF It's one row... -->
                <div v-if="labelsarray.length < 3"class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center" style="min-height: 300px">
                    <div class="cell" v-for="(labels, index) in labelsarray" :id="['item'] + index">
                      <span v-if="labels.label == 'showmore'" class="label container">{{ $t('Show More')}}</span>
                      <span v-else class="label container">{{ labels.label }}</span>
                    </div>
                </div>

              </div>
            </div>
            <template v-if="labelsarray.length > 2">
              <draggable :list="itemsarray"
                animation="600"
                tag="ul"
                class="hrank-responsive"
                handle=".handle"
                :move="onMove"
              >
                <li
                  :id="choice.column"
                  v-for="(choice, index) in itemsarray"
                  class="hrank-item"
                  :key="choice.id"
                  :ref="'main_' + index"
                  role="option"
                  draggable="true"
                  tabindex="1"
                  @keyup.arrow-left="arrowLeft('main', choice, index)"
                  @keyup.arrow-right="arrowRight('main', choice, index)"
                >
                  <div class="handle"></div>
                  <!-- <div class="itemnumber flex items-center absolute right-0 top-0 w-6 justify-center bg-gray-200 cursor-move">{{ index + 1 }}</div> -->
                  <div class="flex-grow h-full align-middle">
                    <span class="align-middle text-base"></span>
                    <div class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center" :id="['item'] + index">
                        <div class="cell" v-for="(attributes, index) in choice.attributes">
                            <span class="label container">{{ attributes.label }}</span>
                            <span class="description" v-html="brToLi(attributes.text)"></span>
                            <div v-if="attributes.label == 'showmore'">
                              <button
                                class="showmore"
                                @click="showModal(index)"
                              >
                                <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                              </button>
                              <card-modal :ref="'modal_' + index">
                                <!-- {{ attributes['showmore'].text }} -->
                              </card-modal>
                            </div>
                        </div>
                    </div>
                  </div>
                </li>
              </draggable>
            </template>
            <template v-if="labelsarray.length < 3">
              <draggable :list="itemsarray" animation="600" tag="ul" class="hrank-responsive short" handle=".handle">
                <li :id="choice.column" v-for="(choice, index) in itemsarray" class="hrank-item">
                  <div class="handle"></div>
                  <!-- <div class="itemnumber flex items-center absolute right-0 top-0 w-6 justify-center bg-gray-200 cursor-move">{{ index + 1 }}</div> -->
                  <div class="flex-grow h-full align-middle">
                    <span class="align-middle text-base"></span>
                    <div class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center" :id="['item'] + index" style="min-height: 300px">
                        <div class="cell" v-for="(attributes, index) in choice.attributes">
                            <span class="label container">{{ attributes.label }}</span>
                            <span class="description" v-html="brToLi(attributes.text)"></span>
                            <div v-if="attributes.label == 'showmore'">
                              <button
                                class="showmore"
                                @click="showModal(index)"
                              >
                                <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                              </button>
                              <card-modal :ref="'modal_' + index">
                                <!-- {{ attributes['showmore'].text }} -->
                              </card-modal>
                            </div>
                        </div>
                    </div>
                  </div>
                </li>
              </draggable>
            </template>
      </div>
    </div>

    <div class="submit-button-wrapper pt-3 lg:pt-0">
      <div v-if="demo !== ('1')">
        <button type="button"
          class="submitResults px-5 py-2"
          :class="{ 'loading': loading }"
          @click="putResults"
          tabindex="1"
        >
          {{ $t('Next') }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i>
        </button>
      </div>

      <div v-else>
        <button type="submit"
          class="submitResults px-5 py-2"
          :class="{ 'loading': loading }"
          @click="restartActivity"
        >
          {{ $t('Restart Demo') }}<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'
import draggable from 'vuedraggable'
import brToLi from '../../mixins/br-to-li.js'

export default {
  display: "Simple",
  order: 1,
  mixins: [brToLi],
  components: {
    draggable,
  },
  props: {
      array: '',
      labels: '',
      route:'',
      demo:'',
  },
  data() {
    return {
      itemsarray: this.getItemsWithColumns(),
      labelsarray: this.labels,
      loading: false,
      alertText: '',
    }
  },
  methods: {
    showModal(index) {
      let modal_id = "modal_" + index;
      this.$refs[modal_id][0].show(index);
    },
    restartActivity() {
      this.loading = true;
      location.reload();
    },
    getItemsWithColumns() {
      return this.array.map((item, index) => {
        item.column = 'column_' + (index + 1);
        return item;
      });
    },
    putResults() {
      this.loading = true;
      axios.put(this.route, {
        results: this.itemsarray.map(dataSet => dataSet.id)
      }).then(function (response) {
        console.log(response);
      }).then(function () {
        location.reload();
      });
    },
    arrowLeft(section, choice, index) {
      if (index > 0) {
        let newIndex = index - 1;
        this.moveItem(index, newIndex);
        this.updateAlertText(choice.attributes.title.text, newIndex);
        this.focusItem(section, newIndex);
      }
    },
    arrowRight(section, choice, index) {
      if (index < this.itemsarray.length - 1) {
        let newIndex = index + 1;
        this.moveItem(index, newIndex);
        this.updateAlertText(choice.attributes.title.text, newIndex);
        this.focusItem(section, newIndex);
      }
    },
    updateAlertText(title, newIndex) {
      this.alertText = title + ', ranked ' + (newIndex + 1) + ' of ' + (this.itemsarray.length);
    },
    moveItem(fromIndex, toIndex) {
      let element = this.itemsarray[fromIndex];
      this.itemsarray.splice(fromIndex, 1);
      this.itemsarray.splice(toIndex, 0, element);
    },
    focusItem(prefix, index) {
      this.$nextTick(() => {
        let el = this.$refs[prefix + '_' + index];

        if (el && el[0]) {
          el[0].focus();
        }
      })
    },
    onMove(move) {
      if (move.draggedContext) {
        let title = move.draggedContext.element.attributes.title.text;
        let newIndex = move.draggedContext.futureIndex;
        this.updateAlertText(title, newIndex)
      }
    },
  },
};
</script>
